export default class Main {
    constructor() {
        this.init();
    }

    init() {
        this.introIn();
        this.switchCard();
        this.setNumer();
    }

    introIn() {
        const card = document.querySelector(".js-nengajo");

        window.addEventListener("load", () => {
            document.body.classList.add("-load");

            setTimeout(() => {
                card.setAttribute("data-card", "ura");
            }, 3000);
        });
    }

    switchCard() {
        const card = document.querySelector(".js-nengajo");

        card.addEventListener("click", () => {
            const state = card.getAttribute("data-card");

            if (state === "ura" || state === "") {
                card.setAttribute("data-card", "omote");
            } else {
                card.setAttribute("data-card", "ura");
            }
        });
    }

    setNumer() {
        const queries = this.getUrlQueries();
        const number = queries.id;
        const card = document.querySelector(".js-number");
        card.innerHTML = number;
    }

    getUrlQueries() {
        const queryStr = window.location.search.slice(1);
        const queries = {};
        queryStr.split("&").forEach((param) => {
            const [key, value] = param.split("=");
            queries[key] = value;
        });
        return queries;
    }
}
